import { render, staticRenderFns } from "./DispositionAssetsFS.vue?vue&type=template&id=67e0babf"
import script from "./DispositionAssetsFS.vue?vue&type=script&lang=ts"
export * from "./DispositionAssetsFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports